import { ErrorDetails, StatusType, VideoErrorCode } from '../../../types/videos'
import { tokens } from '../theme/tokens'

export const setStatus = (status?: StatusType) => {
  const isProcessing = status === undefined || status === 'PROCESSING'
  const isFailed = status === 'FAILED'

  if (isProcessing) {
    return { text: 'Procesando', color: tokens.colors.primary.brand[500] }
  } else if (isFailed) {
    return { text: 'Error', color: tokens.colors.supporting.red[700] }
  } else {
    return { text: 'Listo', color: tokens.colors.supporting.green[700] }
  }
}

export const getErrorTooltip = (errorCode?: VideoErrorCode): string => {
  switch (errorCode) {
    case 'NOT_FOUND':
      return 'El video no fue encontrado.'
    case 'UNSUPPORTED_FORMAT':
      return 'El formato del video no es compatible.'
    case 'PROCESSING_ERROR':
      return 'Hubo un error durante el procesamiento.'
    default:
      return 'Hubo un error al procesar el video.'
  }
}

export const getTooltipText = (status?: StatusType, errorDetails?: ErrorDetails): string => {
  if (!status || status === 'PROCESSING') {
    return 'El video está siendo procesado.'
  } else if (status === 'FAILED') {
    return getErrorTooltip(errorDetails?.errorCode)
  } else {
    return 'El video está listo para mostrarse.'
  }
}
